// extracted by mini-css-extract-plugin
module.exports = {"form":"roles_form__1yOVt","editRoles":"roles_editRoles__2SSGu","actionButton":"roles_actionButton__VxRlV","closeAccount":"roles_closeAccount__1dGOG"};